import {
  CreateIpAllocationImport,
  ReadIpAllocationImport,
} from '@tinct/core-api-models';
import { ApiClient } from '../api-client/api-client';
import {
  ApiCollectionResponse,
  GetCollectionQueryParams,
  GetQueryByIdParams,
} from '../types';

export class IpAllocationImportsEndpoint {
  constructor(private client: ApiClient) {}

  async getIpAllocationImport(
    params: GetQueryByIdParams<ReadIpAllocationImport>,
  ): Promise<ReadIpAllocationImport> {
    return this.client.getById<ReadIpAllocationImport>(
      `/api/v1/ip-allocation/imports/${params.id}`,
      params.fields,
    );
  }

  async getIpAllocationImports(
    params: GetCollectionQueryParams<ReadIpAllocationImport>,
  ): Promise<ApiCollectionResponse<ReadIpAllocationImport>> {
    const { fields, offset, limit, filters, sort } = params;
    return this.client.getCollection<ReadIpAllocationImport>(
      '/api/v1/ip-allocation/imports',
      fields,
      {
        offset,
        limit,
        ...filters,
        sort,
      },
    );
  }

  async createIpAllocationImport(
    body: CreateIpAllocationImport,
  ): Promise<ReadIpAllocationImport> {
    return this.client.post<ReadIpAllocationImport>(
      '/api/v1/ip-allocation/imports',
      body,
    );
  }

  async pauseIpAllocationImport(id: string): Promise<ReadIpAllocationImport> {
    return this.client.post<ReadIpAllocationImport>(
      `/api/v1/ip-allocation/imports/${id}/pause`,
      {},
    );
  }

  async resumeIpAllocationImport(id: string): Promise<ReadIpAllocationImport> {
    return this.client.post<ReadIpAllocationImport>(
      `/api/v1/ip-allocation/imports/${id}/resume`,
      {},
    );
  }

  async retryIpAllocationImport(id: string): Promise<ReadIpAllocationImport> {
    return this.client.post<ReadIpAllocationImport>(
      `/api/v1/ip-allocation/imports/${id}/retry`,
      {},
    );
  }

  async cancelIpAllocationImport(id: string): Promise<ReadIpAllocationImport> {
    return this.client.post<ReadIpAllocationImport>(
      `/api/v1/ip-allocation/imports/${id}/cancel`,
      {},
    );
  }
}
